import React from "react";

const TravelFromSkeleton = () => {
  const SkeletonField = ({ col, labelWidth = "w-28", inputHeight = "h-12" }) => (
    <div className={`flex flex-col ${col}`}>
      <div className={`mb-2 h-3.5 ${labelWidth} rounded-full bg-gray-200`}></div>
      <div className={`${inputHeight} w-full rounded-lg border border-gray-200 bg-gray-50`}></div>
    </div>
  );

  return (
    <div className="w-full px-4 py-6 sm:px-8 md:px-12 lg:px-16">
      <div className="grid animate-pulse grid-cols-1 items-start gap-6 lg:grid-cols-12">
        {/* Sidebar Section Skeleton */}
        <div className="sticky top-4 z-10 flex flex-row overflow-x-auto gap-2 pb-2 scrollbar-none lg:top-6 lg:flex-col lg:gap-3 lg:col-span-3 xl:col-span-3 lg:overflow-visible lg:pb-0">
          {/* Active Section Tab Skeleton */}
          <div className="flex h-[42px] min-w-[140px] shrink-0 items-center justify-between gap-2 rounded-lg bg-gray-200 px-4 py-2.5 lg:h-[64px] lg:p-5 lg:border-l-4 lg:border-l-gray-400">
            <div className="h-4 w-28 rounded-full bg-gray-300 lg:w-36"></div>
            <div className="hidden h-4 w-4 rounded-full bg-gray-300 lg:block"></div>
          </div>

          {/* Inactive Section Tabs Skeletons */}
          {[1, 2, 3, 4].map((item) => (
            <div
              key={item}
              className="flex h-[42px] min-w-[140px] shrink-0 items-center justify-between gap-2 rounded-lg border border-gray-100 bg-white px-4 py-2.5 shadow-sm lg:h-[64px] lg:p-5">
              <div className="h-4 w-24 rounded-full bg-gray-200 lg:w-32"></div>
              <div className="hidden h-4 w-4 rounded-full bg-gray-200 lg:block"></div>
            </div>
          ))}
        </div>

        {/* Main Form Content Card Skeleton */}
        <div className="flex flex-col gap-6 lg:col-span-9 xl:col-span-9">
          <div className="rounded-lg border border-gray-100 bg-white p-6 shadow-sm md:p-8">
            {/* Card Title Header */}
            <div className="mb-8 flex items-center gap-3 border-b border-gray-50 pb-5">
              <div className="h-10 w-10 shrink-0 rounded-lg bg-gray-200"></div>
              <div className="h-7 w-48 rounded-full bg-gray-200"></div>
            </div>

            {/* Form Fields Grid */}
            <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
              <SkeletonField col="md:col-span-12 lg:col-span-4" labelWidth="w-24" />
              <SkeletonField col="md:col-span-12 lg:col-span-4" labelWidth="w-28" />
              <SkeletonField col="md:col-span-6 lg:col-span-4" labelWidth="w-20" />

              <SkeletonField col="md:col-span-4" labelWidth="w-24" />
              <SkeletonField col="md:col-span-4" labelWidth="w-32" />
              <SkeletonField col="md:col-span-4" labelWidth="w-20" />

              <SkeletonField col="md:col-span-6 lg:col-span-4" labelWidth="w-28" />
              <SkeletonField col="md:col-span-4" labelWidth="w-24" />
              <SkeletonField col="md:col-span-4" labelWidth="w-24" />

              <SkeletonField col="md:col-span-4" labelWidth="w-20" />
              <SkeletonField col="md:col-span-12 lg:col-span-8" labelWidth="w-36" />

              <SkeletonField col="md:col-span-12 lg:col-span-4" labelWidth="w-28" />
              <SkeletonField col="md:col-span-12 lg:col-span-4" labelWidth="w-24" />
              <SkeletonField col="md:col-span-12 lg:col-span-4" labelWidth="w-32" />
            </div>
          </div>

          {/* Footer Action Buttons Skeleton */}
          <div className="flex items-center justify-end gap-3 rounded-lg border border-gray-100 bg-white px-6 py-4 shadow-sm">
            <div className="h-11 w-32 rounded-lg bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelFromSkeleton;
